import React, { useState, useEffect } from 'react';
import LoginPopup from './LoginPopup';
import {jwtDecode} from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const validateToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime; // El token es válido si no ha expirado
    } catch (err) {
      return false; // Token inválido
    }
  };

  useEffect(() => {
    const valid = validateToken();
    setIsAuthenticated(valid);
    setShowLoginPopup(!valid);

    // Comprobar periódicamente la validez del token
    const interval = setInterval(() => {
      const stillValid = validateToken();
      setIsAuthenticated(stillValid);
      setShowLoginPopup(!stillValid);
    }, 30000); // Verificar cada 30 segundos

    return () => clearInterval(interval); // Limpiar el intervalo
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setShowLoginPopup(false);
  };

  if (showLoginPopup) {
    return <LoginPopup onLoginSuccess={handleLoginSuccess} />;
  }

  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
